module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ./node_modules/readable-stream/passthrough.js
// module id = 1162
// module chunks = 3